import * as Sentry from '@sentry/react';

// Tipos para os contextos de erro
interface PartnerErrorContext {
  step?: string;
  action?: string;
  component?: string;
  [key: string]: any;
}

// Função para capturar erros de API nos componentes Partner
export const capturePartnerApiError = (
  error: any,
  context: PartnerErrorContext
) => {
  Sentry.captureException(error, {
    tags: {
      component: context.component || 'partner-component',
      action: context.action || 'api_call',
      step: context.step || 'unknown',
    },
    contexts: {
      partner: context,
    },
    level: 'error',
  });
};

// Função para capturar mensagens de erro nos componentes Partner
export const capturePartnerMessage = (
  message: string,
  context: PartnerErrorContext,
  level: Sentry.SeverityLevel = 'error'
) => {
  Sentry.captureMessage(message, {
    level,
    tags: {
      component: context.component || 'partner-component',
      action: context.action || 'user_action',
      step: context.step || 'unknown',
    },
    contexts: {
      partner: context,
    },
  });
};

// Função para capturar erros de validação
export const captureValidationError = (
  field: string,
  value: any,
  context: PartnerErrorContext
) => {
  Sentry.captureMessage(`Validation error in partner form: ${field}`, {
    level: 'warning',
    tags: {
      component: context.component || 'partner-component',
      action: 'validation_error',
      field,
      step: context.step || 'unknown',
    },
    contexts: {
      partner: {
        ...context,
        validation: {
          field,
          value: typeof value === 'object' ? JSON.stringify(value) : value,
        },
      },
    },
  });
};

// Função para capturar erros de upload de arquivos
export const captureFileUploadError = (
  error: any,
  fileName: string,
  context: PartnerErrorContext
) => {
  Sentry.captureException(error, {
    tags: {
      component: context.component || 'partner-component',
      action: 'file_upload_error',
      step: context.step || 'unknown',
    },
    contexts: {
      partner: {
        ...context,
        file_upload: {
          fileName,
        },
      },
    },
    level: 'error',
  });
};

// Função para capturar erros de autenticação
export const captureAuthError = (
  error: any,
  context: PartnerErrorContext
) => {
  Sentry.captureException(error, {
    tags: {
      component: context.component || 'partner-component',
      action: 'auth_error',
      step: context.step || 'unknown',
    },
    contexts: {
      partner: context,
    },
    level: 'warning',
  });
};

// Função para adicionar breadcrumbs de navegação
export const addPartnerBreadcrumb = (
  message: string,
  context: PartnerErrorContext,
  level: Sentry.SeverityLevel = 'info'
) => {
  Sentry.addBreadcrumb({
    category: 'partner-navigation',
    message,
    level,
    data: context,
  });
};

// Função para capturar erros específicos do wizard
export const captureWizardError = (
  error: any,
  step: string,
  action: string,
  additionalContext?: Record<string, any>
) => {
  capturePartnerApiError(error, {
    component: 'PartnerWizard',
    step,
    action,
    ...additionalContext,
  });
};
